import { GetStaticProps } from "next";
import { useTranslation } from "next-i18next";
import { NextSeo } from "next-seo";
import { useRouter } from "next/router";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { PageDataFetchError, useCurrentChainInfo } from "@looksrare/utils";
import { getCanonicalAndLanguageAlternates } from "config/seo";
import { RafflesHistoryView } from "views/win/userGeneratedRaffles/RafflesHistoryView";
import { WinPageLayout } from "views/win/WinPageLayout";

const RafflesPage: React.FC<React.PropsWithChildren> = () => {
  const { t } = useTranslation();
  const router = useRouter();
  const currentChainInfo = useCurrentChainInfo();

  const title = "Raffles";
  const description =
    "Feeling lucky? With LooksRare Raffles, every entry you buy increases your odds of winning top-tier NFT and crypto prizes. Find out more at LooksRare.";
  const { canonical, languageAlternates } = getCanonicalAndLanguageAlternates(
    "/raffles/history",
    router,
    currentChainInfo.appUrl
  );

  return (
    <WinPageLayout>
      <NextSeo
        noindex
        nofollow
        title={title}
        description={description}
        openGraph={{
          url: canonical,
          title: t("{{pageTitle}} | LooksRare", { pageTitle: title }),
          description: description,
          images: [
            {
              url: `${currentChainInfo.appUrl}/images/raffle/meta.png`,
              alt: "Raffle",
              width: 1600,
              height: 900,
              type: "image/png",
            },
          ],
        }}
        canonical={canonical}
        languageAlternates={languageAlternates}
      />
      <RafflesHistoryView />
    </WinPageLayout>
  );
};

export const getStaticProps: GetStaticProps = async ({ locale = "en" }) => {
  try {
    return {
      props: {
        ...(await serverSideTranslations(locale)),
      },
    };
  } catch (e) {
    console.error(e);
    throw new PageDataFetchError("raffles/history", e);
  }
};

export default RafflesPage;
